import Alert from "@pathwright/ui/src/components/alert/Alert"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { useScrollContext } from "@pathwright/ui/src/components/scroll/ScrollView"
import { getResourceSlugId } from "@pathwright/web/src/modules/utils/urls"
import ConnectStores from "lib/core/store/components/ConnectStores"
import ResourceAbout from "library/show/components/about/ResourceAbout"
import ResourceCommunity from "library/show/components/community/ResourceCommunity"
import ResourcePath from "library/show/components/path/ResourcePath"
import get from "lodash/get"
import { useEffect } from "react"
import LibraryResource from "./LibraryResource"

// Responsible for toggling the Resource__<resourceId> class name on the
// document.body used by schools to style resources differently.
const toggleBodyClassName = (resourceSlug) => {
  if (resourceSlug) {
    // Update document.body with Resource__<resourceId> class name.
    const resourceId = getResourceSlugId(resourceSlug)
    if (resourceId) {
      document.body.classList.add(`Resource__${resourceId}`)
    }
  } else {
    // Remove all Resource__<resourceId> classes from document.body
    const re = /Resource__\d+/
    const classes = [...document.body.classList]
    classes.forEach((klass) => {
      if (re.test(klass)) document.body.classList.remove(klass)
    })
  }
}

const getSection = (section) => {
  switch (section) {
    case "about":
      return ResourceAbout
    case "path":
      return ResourcePath
    case "community":
      return ResourceCommunity
  }
}

const LibraryResourceContainer = (props) => {
  const {
    isLoading,
    section,
    children,
    resource,
    offering,
    path,
    error,
    match,
    permissions,
    location,
    mode
  } = props

  const { scrollTo } = useScrollContext()

  useEffect(() => {
    toggleBodyClassName(match.params.resourceSlug)
    return toggleBodyClassName
  }, [])

  // Ensure we're scrolled to the top initially
  useEffect(() => {
    scrollTo(0)
  }, [section])

  const Section = getSection(section)

  return (
    <LibraryResource
      isLoading={isLoading}
      section={section}
      communityArea={get(match.params, "communityArea")}
      resource={resource}
      offering={offering}
      mode={mode}
      permissions={permissions}
      path={path}
    >
      {error ? (
        <Alert error={error} />
      ) : isLoading ? (
        <LoadingCircle inverted={true} />
      ) : (
        <>
          <Section params={match.params} location={location} />
          {children}
        </>
      )}
    </LibraryResource>
  )
}

LibraryResourceContainer.displayName = "LibraryResourceContainer"

const mapStateToProps = function (state, ownProps) {
  let {
    resource,
    offering,
    section,
    offering_error,
    offerings_error,
    resource_error
  } = state.resourceStore.state
  const { path, mode } = state.pathStore.state
  const permissions = state.resourceStore.request.permissions()

  // TODO: handle the loaded resource but no offering case?
  const isLoading = resource == null || offering == null || permissions == null

  const error = resource_error || null
  offering_error = offering_error || offerings_error || null

  const props = _.assign(
    {},
    {
      resource,
      offering,
      path,
      section,
      permissions,
      mode,
      isLoading,
      error,
      offering_error
    },
    ownProps
  )

  return props
}

const resourceWatchEvents = [
  "resource",
  "offering",
  "offerings_error",
  "section",
  "registration",
  "offerings_error",
  "offering_error",
  "resource_error"
]

const stores = [
  { store: "path", watch: ["mode", "path"] },
  { store: "resource", watch: resourceWatchEvents }
]

export default ConnectStores(
  LibraryResourceContainer,
  stores,
  {},
  mapStateToProps
)
